import { Label as LabelDs, LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";

import InputDs from "ds/Input";
import { breakpoints } from "Libs/theme";

export const Form = styled.form`
  background-color: var(--section-snow-background-color, var(--snow));
  box-sizing: border-box;
  padding: 32px;
  width: 100%;
  text-align: left;
  textarea {
    width: 100%;
  }
`;

export const Region = styled.div`
  width: 264px;
  margin-bottom: 26px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const Label = styled(LabelDs)`
  margin-bottom: 0px;
`;

export const SelectWrapper = styled.div`
  max-width: 264px;

  @media (max-width: 768px) {
    max-width: unset;
  }
`;

export const FormFields = styled.section`
  display: block;
  max-width: 100%;

  @media (min-width: ${breakpoints[1]}) {
    max-width: 600px;
    column-gap: 32px;
  }
`;

export const Input = styled(InputDs)`
  margin-bottom: 16px;
  & > input {
    width: 264px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const Loading = styled(LoadingDs)`
  margin-top: 16px;
`;
